import React, { Component } from 'react';
import Button from 'components/ReactButton';
import BackButton from 'components/BackButton';
import { required, maxLength } from 'helpers/validate';
import { validateForm } from 'helpers/validateForm';
import classNames from 'classnames';
import Svg from 'components/Svg';
import styles from './styles.scss';
import InputWithValidation from '../InputWithValidation';

const validationRules = {
  metaKey: [
    required(() => 'You must enter a key'),
    maxLength(30, () => 'Metakey should be 30 characters or less'),
  ],
  metaValue: [
    required(() => 'You must enter a value'),
    maxLength(50, () => 'Metavalue should be 50 characters or less'),
  ],
};
export default class InnerCardMetadata extends Component {
  titleStyles = classNames('h2', styles.titleAdditionalStyles)

  constructor(props) {
    super(props);

    this.state = {
      metadatas: this.parseMetadata(this.props),
      errors: null,
    };
  }

  handleAddMetadata = () => {
    if (this.state.metadatas.some(md => md.key === this.state.metaKey && md.value === this.state.metaValue)) {
      this.setState({
        errors:
        {
          hasErrors: true,
          metaKey: ['Cannot add duplicate metadata key and value'],
          metaValue: ['Cannot add duplicate metadata key and value'],
        },
      });
      return;
    }

    if (this.state.metadatas.length === 10) {
      this.setState({
        errors:
        {
          hasErrors: true,
          metaKey: ['No more than 10 metadata items can be filtered at once'],
        },
      });
      return;
    }

    const errors = validateForm(validationRules, this.state);
    if (errors.hasErrors) {
      this.setState({ errors });
      return;
    }
    this.setState({ errors: {} });

    this.setState(prevState => ({
      metadatas: [...prevState.metadatas, { key: prevState.metaKey, value: prevState.metaValue }],
      metaKey: '',
      metaValue: '',
    }));
  };

  handleCancel = () => {
    this.props.onCancel();
  };

  handleSubmit = () => {
    this.props.onSubmit(this.state.metadatas);
  };

  handleRemove(metadata) {
    this.setState(prevState => ({ metadatas: prevState.metadatas.filter(md => !(md.key === metadata.key && md.value === metadata.value)) }));
  }

  parseMetadata = (props) => {
    let metadatas = [];
    if (props.metadatas && props.metadatas.length > 0) {
      if (typeof props.metadatas[0] === 'string' || props.metadatas[0] instanceof String) {
        metadatas = props.metadatas.map(md => ({
          key: md.split(':')[0],
          value: md.split(':')[1],
        }));
      } else {
        metadatas = props.metadatas;
      }
    }

    if (props.metaKey) {
      metadatas.push({ key: props.metaKey, value: props.metaValue });
    }

    return metadatas;
  }

  renderSelectedMetadata = () => (
    <div className={styles.selectedMetadataContainer}>
      {this.state.metadatas.length > 0
        ? this.state.metadatas.map(md => (
          <div
            key={md.key + md.value}
            role="button"
            onClick={() => this.handleRemove(md)}
            className={styles.selectedMetadata}
          >
            <Svg className={styles.crossIcon} name="crossCircle" />
            {md.key} : {md.value}
          </div>
        ))
        : (
          <div
            className={styles.selectedMetadata}
          >
            No metadata added
          </div>
        )}
    </div>
  );

  render() {
    const {
      subText,
      title,
    } = this.props;
    const { metaKey, metaValue, errors } = this.state;
    return (
      <div className={classNames(styles.container, { [styles.expanded]: localStorage.getItem('sidebar.expanded') === 'true' })}>
        <div className={styles.titleContainer}>
          <div className={styles.backButtonContainer}>
            <BackButton onBack={this.handleSubmit} />
          </div>
          <h1 className={this.titleStyles}>{title}</h1>
          <div className={styles.subTitleButtonContainer}>
            {subText && (
              <p>{subText}</p>
            )}
          </div>
        </div>
        <div className={styles.addMetadataContainer}>
          <div className={styles.metadataInput}>
            <InputWithValidation
              id="metaKeyId"
              type="text"
              value={metaKey}
              name="metaKey"
              onChange={e => this.setState({ metaKey: e.target.value })}
              label="Key"
              errors={errors}
            />
            <InputWithValidation
              id="metaValueId"
              type="text"
              value={metaValue}
              name="metaValue"
              onChange={e => this.setState({ metaValue: e.target.value })}
              label="Value"
              errors={errors}
            />
            <Button
              id="addMetadata"
              className={styles.addMetadataButton}
              onClick={this.handleAddMetadata}
            >
              + Add Metadata
            </Button>
          </div>
          {this.renderSelectedMetadata()}
        </div>

        <div className={`${styles.buttonsRow}`}>
          <Button className={styles.button} onClick={this.handleSubmit}>Apply</Button>
          <Button className={styles.button} theme="grey" onClick={this.handleCancel}>Cancel</Button>
        </div>
      </div>
    );
  }
}
